import Paginator from '../components/common/Paginator.vue'


export const paginationMixin = {
    components: {
        Paginator
    },
    data() {
        return {
            params: {},
            pageSize: 20,
            totalPages: 20,
            totalElements: 0,
            pageNumber: 1,
            loading: false,
        }
    },
    computed: {},
    methods: {
        changePage(page) {
            const self = this;
            this.getData(self.params, page)
        },
        getData() {

        }
    }
}



// WEBPACK FOOTER //
// ./src/util/paginationMixin.js